import React from "react";

import Background from "@images/backgrounds/contact-us-desktop-bg.png";

import { Box } from "@mantine/core";
import styles from "@scss/custom-components/background.module.scss";

export const CustomBackground: React.FC = () => {
  return (
    <div className={styles.backgroundWrapperOuter}>
      <Box
        className={styles.backgroundImage}
        style={{ backgroundImage: `url(${Background})` }}
      ></Box>
    </div>
  );
}
